<template>
  <div
    v-show="!paySuccess"
    :class="['pay-member-box ' + whichType, { supervip2: !hasVip && whichType === 'supervip' }]"
  >
    <div class="pay-header">
      <div class="left">
        <img class="avatar" :src="setUserAvatars(userInfo.avatar).src" alt="" />
        <div class="avatar-info">
          <p>
            充值账号：<span>{{ userInfo.account }}</span>
          </p>
          <div class="btn" @click="changeAccount">切换账号></div>
        </div>
      </div>
      <div class="right" @click="closePayMember">
        <svg-icon name="digclose" class="close"></svg-icon>
      </div>
    </div>
    <div class="bg">
      <div class="pay-container">
        <ul class="pay-tab">
          <li
            v-for="item in payType[whichType].tab"
            :class="[
              item.type,
              {
                actived: item.type == whichType,
                supervip2: !hasVip && item.type === 'supervip'
              }
            ]"
            @click="setPayClick(item.type)"
            :key="item.type"
          >
            <svg-icon
              :name="item.type"
              class="pay-tab-svg"
              v-if="item.type == whichType"
            ></svg-icon>
            <div class="pay-tab-intro">
              <span class="tab-name">{{ item.name }}</span>
              <span class="tab-des">{{ item.des }}</span>
            </div>
          </li>
        </ul>
        <div class="content-box">
          <div class="aside">
            <div>
              <p class="aside-title">{{ payType[whichType].title }}</p>
              <p class="aside-sub-title">{{ payType[whichType].sub_title }}</p>
              <div class="line"></div>
              <ul class="pay-des">
                <li v-for="item in payType[whichType].des" :key="item">
                  <svg-icon name="geryRight" class="geryRight"></svg-icon>
                  <span>{{ item }}</span>
                </li>
              </ul>
              <div class="btn" @click="equityContrast = true">查看权益对比></div>
            </div>
            <div v-if="whichType == 'minivip'">
              <div class="line line2"></div>
              <a
                class="qybuy"
                href="https://app.olcad.com/company/paynew"
                target="_blank"
                rel="noopener noreferrer"
              >
                <svg-icon name="qyicon" class="qyicon"></svg-icon>
                企业采购>
              </a>
            </div>
          </div>
          <div class="content">
            <ul class="thali">
              <template v-for="(item, index) in payType[whichType].thali" :key="item.time">
                <li
                  v-if="item.show"
                  :class="{ active: item.time == curThail.time }"
                  @click="choseThaliFun(item)"
                >
                  <div v-if="index == 0" class="tips">超值</div>
                  <p class="time">{{ item.time }}</p>
                  <p class="price">
                    ¥<span>{{ item.price }}</span>
                  </p>
                  <p class="des">{{ item.des }}</p>
                </li>
              </template>
            </ul>
            <div class="order">
              <div class="title">支付订单</div>
              <div class="order-content">
                <div class="order-content">
                  <div class="code-box">
                    <div class="code-img" v-if="!codeTip.state">
                      <qrcode-vue
                        v-if="codeTip.url"
                        :value="codeTip.url"
                        level="H"
                        :size="codeTip.size"
                      />
                    </div>
                    <div v-else class="nocode">
                      <p v-show="codeTip.title">{{ codeTip.title }}</p>
                      <div v-show="codeTip.btnTxt" class="btn" @click="getPayCode">
                        {{ codeTip.btnTxt }}
                      </div>
                    </div>
                    <span>微信/支付宝 扫码支付</span>
                  </div>
                </div>
                <div class="pay-info">
                  <div
                    v-if="showPacket"
                    class="minus"
                    @click="chosePacketFun"
                    @mouseenter="packetEnter"
                    @mouseleave="packetLeave"
                  >
                    <div class="packet">
                      <svg-icon :name="packetState" size="20px"></svg-icon>
                      <span>{{
                        !usePack
                          ? `点击领取${packetTitle}，立减${packetPrice}元`
                          : `已领取${packetTitle}`
                      }}</span>
                    </div>
                    <span v-if="usePack">{{ `已减¥${packetPrice}` }}</span>
                  </div>
                  <p class="pay-price">
                    实付：<span class="text1">¥</span
                    ><span class="text2">{{
                      !usePack || !showPacket ? curThail.price : curThail.price - packetPrice
                    }}</span>
                  </p>
                  <div class="agree-clause" @click="setAgreeAgreement">
                    <svg-icon :name="needAgree ? 'checked' : 'noCheck'" class="svg-icon"></svg-icon>
                    <span></span>
                    &nbsp;
                    <a
                      @click.stop=""
                      target="_blank"
                      :href="linkURL1 + '/agreement.html'"
                      rel="noopener noreferrer"
                    >
                      会员使用协议
                    </a>
                    <div class="divider">|</div>
                    <a
                      @click.stop=""
                      target="_blank"
                      :href="linkURL1 + '/agreementuser.html'"
                      rel="noopener noreferrer"
                    >
                      用户协议
                    </a>
                    <div class="divider">|</div>
                    <a
                      @click.stop=""
                      target="_blank"
                      :href="linkURL1 + '/onlineservice.html'"
                      rel="noopener noreferrer"
                    >
                      在线协议
                    </a>
                    &nbsp;
                    <span>等5项协议</span>
                  </div>
                  <div class="agree-clause" @click="needInvoice = !needInvoice">
                    <svg-icon
                      :name="needInvoice ? 'checked' : 'noCheck'"
                      class="svg-icon"
                    ></svg-icon>
                    <span>开具发票</span>
                  </div>
                </div>
              </div>
            </div>
            <div class="note-box">
              <p>
                <span>注：</span>
                <span v-show="whichType == 'minivip'">*迷你CAD会员不包含图库会员</span>
                &nbsp;
                <span>*购买后不支持7天无理由退货</span>
              </p>
              <a target="_blank" :href="linkURL1 + '/help.html?qa=010305'" rel="noopener noreferrer"
                >会员时间如何计算></a
              >
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="mask"></div>
  <EquityContrast v-model:showThis="equityContrast"></EquityContrast>
  <PayMethod
    v-model:showThis="paySuccess"
    :needInvoice="needInvoice"
    @closeThis="paySuccessShow"
  ></PayMethod>
</template>

<script setup>
import { setUserAvatars } from '@/assets/js/globalfun'
import { useMapState } from '@/assets/js/use_storemap'
import { payType as originPayType } from '@/assets/js/data'
import {
  apiGetPayCode,
  apiGetPayState,
  apiPayCheck,
  apiGalleryPayCheck,
  apiGetPrice
} from '@/api/modules/cad_api'
import { useStore } from 'vuex'
import QrcodeVue from 'qrcode.vue'
import EquityContrast from '@/components/cad/EquityContrast.vue'
import PayMethod from '@/components/cad/PayMethod.vue'
import {
  ref,
  defineProps,
  defineEmits,
  watch,
  computed,
  onMounted,
  onBeforeMount,
  onUnmounted
} from 'vue'

const { userInfo, linkURL1, discountInfo, payPrice, usePack, hasVip } = useMapState({
  userInfo: state => state.userInfo.user_info,
  linkURL1: state => state.realm.linkURL1,
  discountInfo: state => state.cad.discount_info, // 红包相关信息
  payPrice: state => state.cad.payPrice,
  usePack: state => state.cad.use_pack,
  hasVip: state => state.has_vip
})

const props = defineProps({
  needPayMember: {
    type: Boolean,
    required: true
  },
  needWhichOne: {
    type: String,
    required: true
  }
})

const emit = defineEmits(['update:needPayMember', 'setPayMember'])

const store = useStore()

let payType = ref(originPayType)
const curThail = ref() // 套餐
let whichType = ref()
const packetState = ref('Select-No') // 红包状态
const packetPrice = ref(0) // 红包减多少
let packetTitle = ref('')
const needInvoice = ref(false) // 开具发票
const needAgree = ref(true) // 同意协议
const equityContrast = ref(false)
const codeTip = ref({
  state: false,
  which: '',
  title: '二维码获取中...',
  btnTxt: '',
  url: '',
  ordersn: '',
  size: 114
})
const paySuccess = ref(false) // 支付成功?
const delayTimer = ref(null)

onBeforeMount(() => {
  if (usePack.value) packetState.value = 'Select-Yes'
})

onMounted(() => {
  getClientWidth()
  window.addEventListener('resize', () => {
    getClientWidth()
  })
})

onUnmounted(() => {
  clearTime()
})

const changeAccount = () => {
  store.state.cad.login.show = true
}

const closePayMember = () => {
  clearTime()
  emit('update:needPayMember', false)
}
const setPayClick = key => {
  emit('setPayMember', key)
  curThail.value = payType.value[key].thali[0]
  getPayCode()
}

const choseThaliFun = val => {
  curThail.value = val
  getPayCode()
}

// 鼠标hover红包时图标更改
const packetEnter = () => {
  if (!usePack.value) {
    packetState.value = 'Select-Hover'
  }
}

// 鼠标离开红包时图标更改
const packetLeave = () => {
  if (!usePack.value) {
    packetState.value = 'Select-No'
  }
}

const chosePacketFun = () => {
  if (usePack.value) return

  packetState.value = 'Select-Yes'
  store.commit('cad/setCadUsePack', true)
  getPayCode()
}

const clearTime = () => {
  clearTimeout(store.state.cad.check_pay.timer)
  clearTimeout(store.state.cad.check_pay.timer2)
  store.state.cad.check_pay.times = 0
  store.state.cad.check_pay.times2 = 0

  // 延迟处理定时器清除
  if (delayTimer.value) {
    clearTimeout(delayTimer.value)
    delayTimer.value = null
  }
}

// 获取支付二维码。
const getPayCode = () => {
  codeTip.value.state = true
  codeTip.value.title = '二维码获取中...'
  codeTip.value.btnTxt = ''
  clearTime()

  const startTime = Date.now() // 记录开始时间

  let dz_or_va = false
  if (curThail.value.price_id == 48 || curThail.value.price_id == 138) {
    if (usePack.value) {
      dz_or_va = true
    }
  }

  // 封装公共延迟处理逻辑
  const handleResponse = res => {
    const elapsed = Date.now() - startTime
    const delay = Math.max(500 - elapsed, 0)

    delayTimer.value = setTimeout(() => {
      if (res.code == 1) {
        codeTip.value.state = false
        codeTip.value.url = res.param1.url
        codeTip.value.ordersn = res.param1.ordersn
        checkPayState(res.param1.ordersn)
      } else {
        codeTip.value.title = '获取二维码失败，请稍后再试'
      }
    }, delay)
  }

  if (curThail.value.price_id == 'cyear') {
    apiGetPayCode({
      price_id: '',
      usertoken: userInfo.value.user_token,
      osn: '',
      type: 1,
      product: curThail.value.price_id
    }).then(res => handleResponse(res))
  } else {
    apiGetPayCode({
      price_id: curThail.value.price_id,
      usertoken: userInfo.value.user_token,
      osn: dz_or_va ? discountInfo.value.osn : '',
      type: 0
    }).then(res => handleResponse(res))
  }
}

const checkPayState = ordersn => {
  clearTimeout(store.state.cad.check_pay.timer) // 清除已有定时器

  const check = async (retryCount = 0) => {
    try {
      // 先递增计数器
      store.state.cad.check_pay.times = retryCount + 1

      // 超过重试次数处理
      if (store.state.cad.check_pay.times > 300) {
        codeTip.value.state = true
        codeTip.value.title = ''
        codeTip.value.btnTxt = '二维码已过期，点击重新获取'
        codeTip.value.which = 'reload'
        return
      }

      // 发起请求
      const res = await apiGetPayState({ ordersn })

      if (res.code == 1) {
        codeTip.value.state = true
        codeTip.value.title = '扫码成功'
        codeTip.value.which = 'success'
        codeTip.value.btnTxt = '点击重新获取'

        getPayState(ordersn)
      } else {
        // 继续轮询
        store.state.cad.check_pay.timer = setTimeout(() => check(retryCount + 1), 1000)
      }
    } catch (error) {
      console.error('支付状态检查异常:', error)
      clearTimeout(store.state.cad.check_pay.timer) // 出错时清除定时器
    }
  }

  // 首次执行检查
  store.state.cad.check_pay.timer = setTimeout(check, 1000)
}

// 用户扫码成功后，获取支付状态
const getPayState = ordersn => {
  clearTimeout(store.state.cad.check_pay.timer2) // 清除已有定时器

  const createChecker = () => {
    return props.which == 'gallery'
      ? () =>
          apiGalleryPayCheck({
            usertoken: userInfo.value.user_token,
            ordersn: ordersn,
            from: 'newweb'
          })
      : () => apiPayCheck({ Ordersn: ordersn })
  }

  const check = async (attempt = 0) => {
    try {
      // 先更新计数器
      store.state.cad.check_pay.times2 = attempt + 1

      // 终止条件检查
      if (store.state.cad.check_pay.times2 > 300) {
        clearTimeout(store.state.cad.check_pay.timer2)
        return
      }

      // 执行检查
      const res = await createChecker()()

      if (res.code == 1) {
        clearTimeout(store.state.cad.check_pay.timer2)
        paySuccess.value = true
      } else {
        // 继续轮询
        store.state.cad.check_pay.timer2 = setTimeout(() => check(attempt + 1), 1000)
      }
    } catch (error) {
      console.error('支付状态检查异常:', error)
      clearTimeout(store.state.cad.check_pay.timer2) // 出错时清除定时器
    }
  }

  // 立即开始第一次检查
  check(0)
}

const setAgreeAgreement = () => {
  needAgree.value = !needAgree.value
  if (!needAgree.value) {
    codeTip.value.state = true
    codeTip.value.title = '请阅读并接受协议'
  } else {
    codeTip.value.state = false
  }
}

// 通用价格设置函数
const updatePrices = (items, priceData, options = {}) => {
  const ID_MAPPING = {
    1: 'one',
    2: 'six',
    3: 'month',
    4: 'yj'
  }

  return items.map(item => {
    const priceKey = ID_MAPPING[item.id]
    const priceItem = priceData?.[priceKey]

    // 基础属性更新
    if (priceItem) {
      item.price = priceItem.money
      item.price_id = priceItem.price_id
      item.des = priceItem.tip
    }

    // 处理特殊字段（如show）
    if (options.handleShowForIds?.includes(item.id)) {
      item.show = !!priceItem
    }

    return { ...item } // 保持响应性，创建新对象
  })
}

const paySuccessShow = state => {
  if (state) {
    closePayMember()
  }
}

let originalWidth = null
function getClientWidth() {
  const clientWidth = window.innerWidth || document.body.offsetWidth

  // 首次调用时保存原始宽度
  if (!originalWidth) {
    originalWidth = codeTip.value.size
  }

  // 根据窗口宽度选择缩放比例
  let scale = 1
  if (clientWidth >= 1921 && clientWidth <= 2560) scale = 1.2
  else if (clientWidth > 2560) scale = 2

  codeTip.value.size = originalWidth * scale
}

const showPacket = computed(() => {
  if (curThail.value.price_id == 48 || curThail.value.price_id == 138) {
    return true
  } else {
    return false
  }
}) // 是否有红包

watch(
  () => props.needWhichOne,
  newVal => {
    whichType.value = newVal

    if (!hasVip.value) {
      if (whichType.value == 'galleryvip') {
        whichType.value = 'supervip'
      }
      delete payType.value['galleryvip']
      for (let k in payType.value) {
        payType.value[k].tab = payType.value[k].tab.filter(item => item.type != 'galleryvip')
      }
    }

    curThail.value = payType.value[whichType.value].thali[0]
  },
  { immediate: true }
)

watch(
  () => discountInfo.value,
  newVal => {
    if (!newVal || Object.keys(newVal).length == 0) return

    if (newVal.dis) packetPrice.value = newVal.dis
    if (newVal.info.title) packetTitle.value = newVal.info.title
  },
  { deep: true, immediate: true }
)

watch(
  () => payPrice.value,
  async newVal => {
    codeTip.value.state = true
    codeTip.value.title = '二维码获取中...'
    codeTip.value.btnTxt = ''

    if (!newVal || Object.keys(newVal).length == 0) {
      try {
        const res = await apiGetPrice({ usertoken: userInfo.value.user_token })
        if (res.code === 1) {
          store.state.cad.payPrice = res.param1
        } else {
          msg.e({ msg: '获取价格失败，请稍后再试~' })
        }
      } catch (error) {
        msg.e({ msg: '获取价格失败，请稍后再试~' })
      }
      return
    }

    // 更新迷你会员价格（含show字段处理）
    payType.value.minivip.thali = updatePrices(
      payType.value.minivip.thali,
      newVal.vip,
      { handleShowForIds: [3, 4] } // 需要处理show的ID
    )

    // 更新超级会员价格
    payType.value.supervip.thali = updatePrices(payType.value.supervip.thali, newVal.svip)
    getPayCode()
  },
  { deep: true, immediate: true }
)
</script>

<style lang="scss" scoped>
@import '@/assets/scss/common.scss';
@import '@/assets/scss/_make.scss';
.pay-member-box {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 999;
  background-repeat: no-repeat;
  background-size: contain;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  overflow: hidden;

  @include responsive-style(
    (
      width: 794px,
      height: 572px,
      border-radius: 10px
    )
  );
  .pay-header {
    display: flex;
    justify-content: space-between;
    @include responsive-style(
      (
        padding: 10px 16px 10px 20px
      )
    );

    .left {
      display: flex;
      align-items: center;
      .avatar {
        border-radius: 50%;
        @include responsive-style(
          (
            width: 44px,
            height: 44px,
            margin-right: 8px
          )
        );
      }
      .avatar-info {
        p {
          color: #fff;
          font-weight: 500;
          @include responsive-style(
            (
              font-size: 14px,
              margin-bottom: 4px
            )
          );
        }
        .btn {
          color: #fff;
          font-weight: 400;
          @include responsive-style(
            (
              border-radius: 2px,
              height: 20px,
              padding: 1px 4px,
              width: 65px,
              font-size: 12px
            )
          );
        }
      }
    }

    .right {
      display: flex;
      align-items: center;
      justify-content: center;
      flex-shrink: 0;
      cursor: pointer;
      @include responsive-style(
        (
          width: 28px,
          height: 28px
        )
      );
      .close {
        @include responsive-style(
          (
            width: 12px,
            height: 12px
          )
        );
      }
    }
  }
  .bg {
    .pay-container {
      @include responsive-style(
        (
          width: 782px,
          border-bottom-left-radius: 10px,
          border-bottom-right-radius: 10px
        )
      );
    }

    .pay-container {
      background-repeat: no-repeat;
      background-size: cover;
      @include responsive-style(
        (
          width: 794px,
          border-bottom-left-radius: 10px,
          border-bottom-right-radius: 10px,
          margin-top: -12px
        )
      );
      .pay-tab {
        display: flex;
        width: 100%;
        li {
          display: flex;
          justify-content: center;
          align-items: center;
          box-sizing: border-box;
          color: #5c6470;
          font-weight: 500;
          position: relative;
          cursor: pointer;
          user-select: none;
          @include responsive-style(
            (
              height: 42px,
              padding: 12px 16px,
              font-size: 14px,
              margin-top: 12px
            )
          );
          .pay-tab-svg {
            @include responsive-style(
              (
                width: 24px,
                height: 24px,
                margin-right: 5px
              )
            );
          }

          .tab-des {
            vertical-align: baseline;
            @include responsive-style(
              (
                font-size: 14px
              )
            );
          }

          &.actived {
            color: #000;
            font-weight: 500;
            @include responsive-style(
              (
                font-size: 16px
              )
            );
          }

          &.minivip {
            @include responsive-style(
              (
                width: 252px
              )
            );
          }
          &.galleryvip {
            @include responsive-style(
              (
                width: 220px
              )
            );
          }
          &.supervip {
            flex: 1;
            white-space: nowrap;
          }

          &.supervip2 {
            flex: 0;
            @include responsive-style(
              (
                width: 346px
              )
            );
          }
          &.threevip {
            @include responsive-style(
              (
                width: 252px
              )
            );
          }
        }
      }
      .content-box {
        display: flex;
        width: 100%;
        @include responsive-style(
          (
            height: 452px
          )
        );
        .aside {
          height: 100%;
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          @include responsive-style(
            (
              width: 252px,
              padding: 30px 35px
            )
          );
          .aside-title {
            color: #000;
            text-align: center;
            font-weight: 500;
            @include responsive-style(
              (
                font-size: 12px,
                margin-bottom: 10px
              )
            );
          }
          .aside-sub-title {
            color: #888;
            text-align: center;
            font-weight: 400;
            @include responsive-style(
              (
                font-size: 12px
              )
            );
          }
          .line {
            background: #e8e8e8;
            width: 100%;
            @include responsive-style(
              (
                height: 1px,
                margin: 16px 0
              )
            );

            &.line2 {
              @include responsive-style(
                (
                  margin: 13px 0
                )
              );
            }
          }
          .pay-des {
            li {
              display: flex;
              align-items: center;
              @include responsive-style(
                (
                  margin-bottom: 10px
                )
              );
              .geryRight {
                @include responsive-style(
                  (
                    font-size: 12px,
                    width: 16px,
                    height: 16px,
                    margin-right: 6px
                  )
                );
              }
              span {
                color: #585a5c;
                font-weight: 400;
                white-space: nowrap;
                @include responsive-style(
                  (
                    font-size: 12px
                  )
                );
              }
            }
          }
          .btn {
            color: #3b3b3f;
            text-align: center;
            font-weight: 400;
            @include responsive-style(
              (
                font-size: 12px,
                line-height: 16px,
                margin-top: 16px
              )
            );
          }
          .qybuy {
            display: flex;
            align-items: center;
            justify-content: center;
            margin: 0 auto;
            @include responsive-style(
              (
                width: 122px,
                height: 32px,
                border-radius: 4px,
                border: 1px solid #e2e2e2
              )
            );
            .qyicon {
              @include responsive-style(
                (
                  width: 16px,
                  height: 16px,
                  margin-right: 6px
                )
              );
            }
          }
        }
        .content {
          flex: 1;
          height: 100%;
          @include responsive-style(
            (
              padding: 30px 28px 30px 0
            )
          );
          .thali {
            display: flex;

            li {
              background: #fff;
              position: relative;
              cursor: pointer;
              user-select: none;
              overflow: hidden;
              @include responsive-style(
                (
                  width: 154px,
                  height: 124px,
                  padding: 21px 30px 0,
                  border-radius: 8px,
                  border: 1px solid #e9e9e9,
                  margin-right: 26px
                )
              );
              &:last-child {
                margin-right: 0;
              }
              .tips {
                position: absolute;
                background: #eb5350;
                color: #fff;
                font-weight: 400;
                top: 0;
                right: 0;
                display: flex;
                align-items: center;
                justify-content: center;
                @include responsive-style(
                  (
                    width: 50px,
                    height: 24px,
                    border-top-right-radius: 6px,
                    border-bottom-left-radius: 8px,
                    font-size: 12px,
                    line-height: 17px
                  )
                );
              }
              .time {
                color: #3d3d3d;
                font-weight: 500;

                @include responsive-style(
                  (
                    font-size: 16px,
                    line-height: 17px
                  )
                );
              }
              .price {
                color: #eb5350;
                font-weight: 500;

                @include responsive-style(
                  (
                    font-size: 14px,
                    margin: 9px 0px
                  )
                );
                span {
                  font-weight: 700;

                  @include responsive-style(
                    (
                      font-size: 26px,
                      line-height: 26px
                    )
                  );
                }
              }
              .des {
                color: #9a9a9c;
                font-weight: 400;
                @include responsive-style(
                  (
                    font-size: 12px,
                    line-height: 17px
                  )
                );
              }

              &.active {
                background: rgba(237, 84, 83, 0.06);
                @include responsive-style(
                  (
                    border: 2px solid #ed5454
                  )
                );
              }
            }
          }
          .order {
            background: #fff;
            box-sizing: border-box;
            @include responsive-style(
              (
                border-radius: 8px,
                border: 1px dashed #e8e8e8,
                width: 514px,
                height: 210px,
                padding: 13px 17px,
                margin-top: 14px
              )
            );
            .title {
              color: #333;
              font-weight: 500;
              @include responsive-style(
                (
                  font-size: 14px,
                  margin-bottom: 8px
                )
              );
            }
            .order-content {
              display: flex;
              .code-box {
                box-sizing: border-box;
                @include responsive-style(
                  (
                    margin-right: 16px,
                    border-radius: 6px,
                    border: 1px solid #e8e8e8,
                    padding: 8px 10px,
                    height: 154px
                  )
                );
                .code-img {
                  text-align: center;
                  @include responsive-style(
                    (
                      width: 114px,
                      height: 114px,
                      margin-bottom: 4px
                    )
                  );
                }
                .nocode {
                  display: flex;
                  align-items: center;
                  justify-content: center;
                  flex-direction: column;
                  background-color: rgba(0, 0, 0, 0.8);
                  color: rgb(255, 255, 255);
                  @include responsive-style(
                    (
                      width: 114px,
                      height: 114px,
                      padding: 6px,
                      margin-bottom: 4px,
                      font-size: 12px
                    )
                  );

                  p,
                  .btn {
                    text-align: center;
                  }

                  .btn {
                    text-decoration: underline;
                    cursor: pointer;

                    @include responsive-style(
                      (
                        margin-top: 5px
                      )
                    );
                  }
                }
                span {
                  color: #888;
                  font-weight: 400;
                  white-space: nowrap;
                  text-align: center;
                  @include responsive-style(
                    (
                      font-size: 12px
                    )
                  );
                }
              }
              .pay-info {
                .minus {
                  display: flex;
                  align-items: center;
                  justify-content: space-between;
                  background: rgba(237, 84, 83, 0.1);
                  cursor: pointer;
                  @include responsive-style(
                    (
                      padding: 10px 11px,
                      width: 328px,
                      border-radius: 6px,
                      border: 1px solid #ed5453,
                      margin-bottom: 33px
                    )
                  );
                  .packet {
                    display: flex;
                    align-items: center;
                    .svg-icon {
                      @include responsive-style(
                        (
                          width: 20px,
                          height: 20px,
                          margin-right: 4px
                        )
                      );
                    }
                    span {
                      font-weight: 500;
                      @include responsive-style(
                        (
                          font-size: 14px
                        )
                      );
                    }
                  }
                  span {
                    font-weight: 500;
                    color: #ed5454;
                  }
                }
                .pay-price {
                  color: #495366;
                  font-weight: 400;

                  @include responsive-style(
                    (
                      font-size: 12px,
                      line-height: 14px,
                      margin-bottom: 16px
                    )
                  );
                  .text1 {
                    color: #eb5350;
                    @include responsive-style(
                      (
                        font-size: 14px,
                        line-height: 14px
                      )
                    );
                  }
                  .text2 {
                    color: #eb5350;
                    font-weight: 700;
                    @include responsive-style(
                      (
                        font-size: 26px,
                        line-height: 14px
                      )
                    );
                  }
                }
                .agree-clause {
                  display: flex;
                  align-items: center;
                  color: #676767;
                  font-weight: 400;
                  cursor: pointer;
                  @include responsive-style(
                    (
                      font-size: 12px,
                      margin-bottom: 8px
                    )
                  );
                  .svg-icon {
                    @include responsive-style(
                      (
                        width: 16px,
                        height: 16px,
                        margin-right: 6px
                      )
                    );
                  }

                  a {
                    color: #3b3b3f;
                  }
                  .divider {
                    @include responsive-style(
                      (
                        margin: 0 2px
                      )
                    );
                  }
                }
              }
            }
          }
          .note-box {
            width: 100%;
            display: flex;
            align-items: center;
            justify-content: space-between;
            @include responsive-style(
              (
                margin-top: 20px
              )
            );
            span,
            a {
              color: #888;
              font-weight: 400;
              @include responsive-style(
                (
                  font-size: 12px
                )
              );
            }
          }
        }
      }
    }
  }
  &.minivip {
    background-image: url('@/assets/img/cad/minivip-bg.png');
    .pay-header {
      .left {
        .avatar-info {
          .btn {
            background: #db6d00;
          }
        }
      }
    }
    .bg {
      background: #fff4eb;
      .pay-container {
        background-image: url('@/assets/img/cad/minivip-tab.png');
        .pay-tab {
          .galleryvip {
            @include responsive-style(
              (
                border-right: 1px solid #e4e4e4
              )
            );
          }
        }
      }
    }
  }
  &.galleryvip {
    background-image: url('@/assets/img/cad/galleryvip-bg.png');
    .pay-header {
      .left {
        .avatar-info {
          .btn {
            background: #ea9707;
          }
        }
      }
    }

    .bg {
      background: #fff5eb;
      .pay-container {
        background-image: url('@/assets/img/cad/galleryvip-tab.png');
      }
    }
  }
  &.supervip {
    background-image: url('@/assets/img/cad/supervip-bg.png');
    .pay-header {
      .left {
        .avatar-info {
          .btn {
            background: #4d292d;
          }
        }
      }
    }

    .bg {
      background: #fff3e1;
      .pay-container {
        background-image: url('@/assets/img/cad/supervip-tab.png');

        .galleryvip {
          @include responsive-style(
            (
              border-left: 1px solid #e4e4e4
            )
          );
        }
      }
    }
  }
  &.supervip2 {
    .bg {
      .pay-container {
        background-image: url('@/assets/img/cad/supervip2-tab.png');
      }
    }
  }
  &.threevip {
    background-image: url('@/assets/img/cad/threevip-bg.png');
    .pay-header {
      .left {
        .avatar-info {
          .btn {
            background: #2c61db;
          }
        }
      }
    }
    .pay-container {
      background-image: url('@/assets/img/cad/threevip-tab.png');
    }
  }
}
</style>
